export default __webpack_public_path__ + "static/coinbase-093a4a7e1c7826fcd95a2122587c2ad7.jpg";